<p-toast position="top-right" key="tc"></p-toast>

<div class="min-h-screen flex relative lg:static surface-ground">
    <div id="app-sidebar"
        class="surface-section h-full lg:h-auto hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
        style="width:280px">
        <div class="flex flex-column h-full">
            <app-logo></app-logo>
            <div class="overflow-y-auto">
                <ul class="list-none px-3 pb-3 pt-0 m-0">
                    <li>
                        <!-- <div class="p-3 flex align-items-center justify-content-between text-600">
                            <span class="font-medium text-sm text-900">FAVORITES</span>
                        </div> -->
                        <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a [routerLink]="['dashboard']" routerLinkActive="router-link-active" pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-home mr-2"></i>
                                    <span class="font-medium">Dashboard</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['charge-scan']" routerLinkActive="router-link-active" pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-barcode mr-2"></i>
                                    <span class="font-medium">Neue Scannen</span>
                                </a>
                            </li>
                            <p-divider></p-divider>
                            <!--
                            <li>
                                <a pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-users mr-2"></i>
                                    <span class="font-medium">Team</span>
                                </a>
                            </li>
                            <li>
                                <a pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-comments mr-2"></i>
                                    <span class="font-medium">Messages</span>
                                    <span
                                        class="inline-flex align-items-center justify-content-center ml-auto bg-purple-500 text-0 border-circle"
                                        style="min-width: 1.5rem; height: 1.5rem">3</span>
                                </a>
                            </li>
                            <li>
                                <a pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-chart-bar mr-2"></i>
                                    <span class="font-medium">Auswertungen</span>
                                </a>
                            </li>
                            <li>
                                <a pRipple
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-cog mr-2"></i>
                                    <span class="font-medium">Einstellungen</span>
                                </a>
                            </li>
                            -->
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="mt-auto">
                <div class="text-sm text-center text-bluegray-500 p-1">
                    Version {{ version }} <i class="pi pi-info-circle" (click)="showInfo()"></i>
                </div>
                <p-divider></p-divider>
                @if (this.authenticationService.userIsAdmin()) {
                <ul class="list-none px-3 pt-0 m-0">
                    <li>
                        <a pRipple
                            class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent"
                            pStyleClass="@next" enterClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden"
                            leaveActiveClass="slideup">
                            <i class="pi pi-cog mr-2"></i>
                            <span class="font-medium">Einstellungen</span>
                            <i class="pi pi-chevron-down ml-auto"></i>
                        </a>
                        <ul
                            class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden animation-duration-150 animation-ease-in-out">
                            <!-- <li>
                                    <a pRipple
                                        class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent"
                                        pStyleClass="@next" enterClass="hidden" enterActiveClass="slidedown"
                                        leaveToClass="hidden" leaveActiveClass="slideup">
                                        <i class="pi pi-user mr-2"></i>
                                        <span class="font-medium">Benutzer</span>
                                        <i class="pi pi-chevron-down ml-auto"></i>
                                    </a>
                                    <ul
                                        class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                                        <li>
                                            <a pRipple
                                                class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                                <i class="pi pi-table mr-2"></i>
                                                <span class="font-medium">View</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a pRipple
                                                class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                                <i class="pi pi-search mr-2"></i>
                                                <span class="font-medium">Search</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li> -->
                            <li>
                                <a pRipple [routerLink]="['admin', 'user-list']" routerLinkActive="router-link-active"
                                    class="flex align-items-center cursor-pointer p-3 text-700 hover:surface-100 transition-duration-150 transition-colors border-right-2 border-transparent">
                                    <i class="pi pi-user mr-2"></i>
                                    <span class="font-medium">Benutzer</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                <!-- <hr class="mb-3 mx-3 border-top-1 border-none border-bluegray-600" /> -->
                <p-divider class="border-bluegray-600"></p-divider>
                }

                <ul
                    class="list-none p-2 m-0 hidden origin-bottom animation-duration-150 overflow-hidden animation-ease-in-out">
                    <li>
                        <a [routerLink]="['user-profile']" routerLinkActive="router-link-active" pRipple class="flex align-items-center cursor-pointer p-3 hover:surface-100 border-round text-bluegray-100 
                        transition-duration-150 transition-colors">
                            <i class="pi pi-user mr-2"></i>
                            <span class="font-medium">Profil</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="logout()" pRipple class="flex align-items-center cursor-pointer p-3 hover:surface-100 border-round text-bluegray-100 
                        transition-duration-150 transition-colors">
                            <i class="pi pi-sign-out mr-2"></i>
                            <span class="font-medium">Abmelden</span>
                        </a>
                    </li>
                </ul>
                <a pRipple class="m-3 px-3 py-2 flex align-items-center hover:surface-100 border-round cursor-pointer text-bluegray-100 
                    transition-duration-150 transition-colors" pStyleClass="@prev" enterClass="hidden"
                    enterActiveClass="slidedown" leaveToClass="hidden" leaveActiveClass="slideup">

                    <span class="font-medium">{{ username }}</span>
                    <i class="pi pi-chevron-up ml-auto"></i>
                </a>
            </div>
        </div>
    </div>
    <div class="min-h-screen flex flex-column relative flex-auto">
        <div class="flex justify-content-between align-items-center px-5 surface-0 border-bottom-1 surface-border relative  lg:hidden"
            style="height:60px">
            <div class="flex">
                <a pRipple class="cursor-pointer block lg:hidden text-700 mr-3" pStyleClass="#app-sidebar"
                    enterClass="hidden" enterActiveClass="fadeinleft" leaveToClass="hidden"
                    leaveActiveClass="fadeoutleft" [hideOnOutsideClick]="true">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
           
        </div>
        <div class="flex flex-column flex-auto p-3">
           
            <div class="border-2 border surface-card surface-border  surface-50 flex-auto border-round-xl p-3">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>